import { render, staticRenderFns } from "./SimpleModal.vue?vue&type=template&id=618584e2&scoped=true"
import script from "./SimpleModal.vue?vue&type=script&lang=js"
export * from "./SimpleModal.vue?vue&type=script&lang=js"
import style0 from "./SimpleModal.vue?vue&type=style&index=0&id=618584e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "618584e2",
  null
  
)

export default component.exports